import React, { FunctionComponent } from 'react';
import { Link } from 'gatsby';
import { formatArticleLink } from '../../utils/formatLink';
import { ArticlePreview as ArticlePreviewType } from '../../types/articlePreview';
import { formatDate } from '../../utils/formatDate';
import { InternalLinkIcon } from '../Icons';
import { useScreenSize } from '../../hooks/useScreenSize';
import { urlFor } from '../../utils/imageBuilder';
import './styles.scss';

type ArticlePreviewProps = {
  article: ArticlePreviewType;
}

function limitCharacters(text: string, limit = 100): string {
  return text.slice(0, limit) + (text.length > limit ? '...' : '');
}

const ArticlePreview: FunctionComponent<ArticlePreviewProps> = ({ article }) => {
  const { isMobile } = useScreenSize();
  const imgSrc = urlFor(article.teaser?.image?.asset ? article.teaser.image : article.image).width(150).height(150).fit('clip').quality(90).url();
  const imgAlt = article.teaser?.image ? article.teaser.image.alt : article.image.alt;

  return (
    <Link
      to={formatArticleLink(article)}
      className={`article-preview ${article.highlight ? 'highlight' : ''}`}
    >
      {!isMobile && (
        <img
          src={imgSrc}
          alt={imgAlt}
        />
      )}
      <div>
        <strong>{article.teaser?.title ? article.teaser.title : article.title}</strong>
        {article.teaser?.description && (
          <p>{limitCharacters(article.teaser.description)}</p>
        )}
        {/* <span>{formatDate(article._createdAt)}</span> */}
      </div>
      <InternalLinkIcon />
    </Link>
  );
}

export default ArticlePreview;
